<template>

  <div class="">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >

      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/Assamese">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>ভাউচাৰ পুনৰ প্ৰিণ্ট</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">প্ৰিপেইড ভাউচাৰ পুনৰ প্ৰিণ্ট কৰক</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">
        <form>
          <b-row>
            <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 7px;">
                  <span style="font-weight:600" >Select type <span class="text-danger">*</span></span>
            </b-col>
            <b-col col cols="8" sm="8" md="8" lg="4">
              <b-form-group label="" v-slot="{ ariaDescribedby }">
                <b-row>
                  <b-col col cols="12" sm="12" md="12" lg="6" style="padding-top: 7px;">
                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="V">View Voucher Code</b-form-radio>
                  </b-col>
                  <b-col col cols="12" sm="12" md="12" lg="6" style="padding-top: 7px;">
                    <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" name="some-radios" value="D">Download Voucher</b-form-radio>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
            <b-col col cols="4" sm="3" md="3" lg="1">

            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 7px;">
                  <span style="font-weight:600" >উপভোক্তা নম্বৰ <span class="text-danger">*</span></span>
            </b-col>
            <b-col col cols="8" sm="8" md="8" lg="4">
                <b-form-input type="text" maxlength="12" id="consNo" value=""  placeholder="উপভোক্তা নম্বৰ" trim required />
            </b-col>
            <b-col col cols="4" sm="3" md="3" lg="1">
                  <!-- <b-button @click="sendOtp()" block pill variant="primary" size="md" class="go" style="width:100%">
                    <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                  </b-button> -->

                  <b-button @click="selectFunction()" block pill variant="primary" size="md" class="go" style="width:100%">
                    <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                  </b-button>

            </b-col>
          </b-row>
        <br>
      </form>
    </br>

    <div id="MobileUpdateDiv" style="display:none">
         <b-row>
           <b-col cols=12>
                <h4 style="color:red">Unable to send OTP. Mobile Number Not Updated</h4>
               <a href="MobileUpdate" >Click Here to Update Your Mobile Number</a>
           </b-col>
         </b-row>
       </div>

       <!-- view voucher only div -->

       <div id="ViewVoucherDiv" style="display:none">
          <b-row>
            <b-col cols=12>
                <span class="heading">ভাউচাৰৰ বিৱৰণ</span>
            </b-col>
          </b-row>

             <b-row>
               <b-col col cols='12' sm="12" md="12" lg="12">

                 <b-table  responsive  :items="viewVoucherCodeList" :fields="viewVoucherCodeListFields">
                   <template   v-slot:cell(viewVouchercode)="data">
                     <span  v-html="data.value"></span>
                  </template>
                 </b-table>

                 </b-col>

             </b-row>
         </div>

         <!-- download voucher div -->

    <div id="VoucherDiv" style="display:none">
            <!-- <b-card header-bg-variant="light" header-text-variant="white" header="Payment Receipt" class="cardStyle">
           -->
           <b-row>
             <b-col cols=12>
                 <span class="heading">Voucher Details</span>
             </b-col>
           </b-row>

              <b-row>
                <b-col col cols='12' sm="12" md="12" lg="12">
                  <b-table  responsive  :items="voucherList" :fields="voucherListFields">
                    <template   v-slot:cell(link)="data">
                      <span  v-html="data.value"></span>
                   </template>
                  </b-table>
                  </b-col>

              </b-row>
            <!-- </b-card> -->
      </div>
      <br>

</div>

  </b-container>

</b-overlay>

    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="modalMsg">  </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-info" @click="closeModal()">OK</b-button>
    </b-modal>

    <b-modal id="otpModal" centered no-close-on-esc  no-close-on-backdrop title="OTP Verification" hide-footer>
      <b-overlay
      :show="show1"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style=""
      variant="dark"
      id="loader"
    >
      Enter the OTP received in your mobile number {{consMobile}}
      <b-form-input type="number" id="otp" ></b-form-input><br>
      <b-button class="btn" variant="primary" id="success-btn" @click="verifyOtp()" >Verify</b-button> &nbsp&nbsp
      <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()" >Resend OTP</b-button>
  </b-overlay>
    </b-modal>

  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
var thColor = '#0288d1';
//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
var mobileNo = "";
var consNo = "";
export default {
  name: '',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      consumerNo: '',
      selected: 'V',
      sdCode: '',
      show: false,
      show1:false,
      consMobile:"",
      viewVoucherCodeList : [],
      viewVoucherCodeListFields: [
        { key: 'viewVouchercode', label: 'Vocuher Code',thStyle: {width: '15vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'viewVoucherAmt', label: 'Voucher Amount',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'viewPaymentDate', label: 'Payment Date',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
      ],
      voucherList : [],
      voucherListFields: [
        { key: 'txnId', label: 'Transaction Id',thStyle: {width: '15vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'voucherAmt', label: 'Voucher Amount',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'PaymentDate', label: 'Payment Date',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'link', label: 'Download Voucher',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
        ]
    }
  },
  methods: {
   
   closeModal(){
     this.$bvModal.hide('model')
   },
   selectFunction(){
     var opt = this.selected;
     //console.log(opt);
     if(opt =="V"){
       this.viewVoucherCode();
     }
     else if(opt=="D"){
       this.sendOtp();
     }
   },
   viewVoucherCode(){
     var consNo = document.getElementById("consNo").value;
     this.consumerNo = consNo;
     this.show= true;
     var parent = this;
     axios.post(this.$urlCommon+'/api/web/voucherReprint?consNo='+consNo)
     .then((response) => {
       parent.show= false;
       //console.log(response.data);
       document.getElementById("ViewVoucherDiv").style.display="block";
       document.getElementById("VoucherDiv").style.display="none";
       document.getElementById("MobileUpdateDiv").style.display="none";
       //document.getElementById("ViewVoucherDiv").classList.add("showDetails");
       var temp = [];
       response.data.forEach(element => {

             var len = element.voucherCode.length;
             var vc= "";
             var vcCodeFinal ="";
             if(element.voucherCode.indexOf(',') > -1){
               //console.log("coma is present");
                vc= element.voucherCode.split(",");
                for(let i=0; i<vc.length; i++){
                   vcCodeFinal += "*"+vc[i]+"#<br>";
                }
             }
             else if(element.voucherCode.indexOf('#') > -1){
               //console.log("# is present");
                vc= element.voucherCode.split("#");
                for(let i=0; i<vc.length; i++){
                   vcCodeFinal += "*"+vc[i]+"#<br>";
                }
             }
             else {
               vcCodeFinal="*"+element.voucherCode+"#";
             }

             // var vc= element.voucherCode.split("#");





             var res1= element.paymentDt.split("-");
             var paymentDt = res1[2]+"/"+res1[1]+"/"+res1[0];
             var obj = {
             "viewVouchercode":vcCodeFinal,
             "viewVoucherAmt":element.voucherAmount,
             "viewPaymentDate":element.paymentDt
         }
         temp.push(obj)
       })
       //console.log(temp)
       this.viewVoucherCodeList = temp
     })
     .catch((e) => {
       parent.show= false;
       parent.$bvModal.show('model');
       document.getElementById("modalMsg").innerHTML="Sorry, Consumer / Voucher not found";
     console.log("Caught :::::::::::::::", e.message);

   })
   },
   sendOtp()
     {
      var parent =this;
      
      consNo = document.getElementById("consNo").value;
      if ((consNo.toString().length!=12))
          {
            this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            return;
          }
          parent.show= true;
       axios.post(parent.$urlArms+'/RestAPI/website/otpValidation?consNo='+consNo)
          .then((response) => {

          console.log(response.data);
          var data=response.data;
          var status = data.msg;

          if(status=="success")
          {
          
              if (data.otpGenerated == "Y") {
                parent.$bvToast.toast('OTP Sent Successfully !', {
                  title: `Success`,
                  variant: 'success',
                  solid: true
                });
                parent.$bvModal.show('otpModal');

              }
              else{
               parent.$bvToast.toast('OTP Generation Failed !', {
                  title: `Failed`,
                  variant: 'danger',
                  solid: true
                });
              }
            
          }
          
          else
          {
             parent.show= false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML="Sorry, Consumer Not Found";

          }

        })
        .catch((e) => {
        console.log("Caught", e);
        this.show= false;
      })


     },


     resendOtp()
     {
       var parent =this;

       parent.show1= true;
       axios.post(this.$urlArms+"/RestAPI/website/resendOTP?consNo="+consNo).then(function(response) {
         parent.show1= false;
         if (response.data.msg == "success") {
           parent.$bvToast.toast('OTP Sent Successfully !', {
             title: `Success`,
             variant: 'success',
             solid: true
           });
         }
       else {
           parent.$bvToast.toast('OTP Could not Sent !', {
             title: `danger`,
             variant: 'danger',
             solid: true
           });
         }
       });
     },

 verifyOtp()
   {
     var parent =this;

     var otp = document.getElementById("otp").value;

     parent.show1= true;
     axios.post(parent.$urlCommon+"/api/VerifyOtpVoucher?consNo="+consNo+"&otp="+otp).then(function(response) {
       parent.show1= false;
       parent.show= false;
       //console.log(response.data);

       if (response.data.message == "success") {
         parent.$bvToast.toast('OTP Verified Successfully !', {
           title: `Success`,
           variant: 'success',
           solid: true
         });
         parent.$bvModal.hide('otpModal');
         document.getElementById("VoucherDiv").style.display="block";
         document.getElementById("ViewVoucherDiv").style.display="none";
         document.getElementById("MobileUpdateDiv").style.display="none";
         //document.getElementById("VoucherDiv").classList.add("showDetails");
         var temp = [];
           response.data.voucherData.body.forEach(element => {
                 var res1= element.paymentDt.split("-");
                 var paymentDt = res1[2]+"/"+res1[1]+"/"+res1[0];
                 var obj = {
                 "txnId":element.transactionId,
                 "voucherAmt":element.voucherAmount,
                 "PaymentDate":element.paymentDt,
                 "link": "<a style='padding-left:40%' target='_blank' href='"+element.downloadLink+"'><img src='"+parent.$urlCommon+"/assets/pdf-icon-3.png' height='32px' width='32px'  /></a>"
             }
             temp.push(obj)

         })
         //console.log(temp)
         parent.voucherList = temp
       }
     else {
         parent.$bvToast.toast('OTP not Valid !', {
           title: `danger`,
           variant: 'danger',
           solid: true
         });
         parent.show1= false;
         parent.show= false;
       }
   });
   },


 

  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">
td{
  padding:0.3rem;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.hideDetails
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
}
.showDetails
{
 visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
.paddingLeft30px{
  padding-left: 30px;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
}
@media only screen and (min-device-width: 320px) and (max-device-height: 568px) and (orientation : portrait) and (-webkit-device-pixel-ratio: 2){
  .paddingLeft30px{
    padding-left: 0px;
  }
  .hideDetails
  {
    box-shadow: none;
    padding: 0px;
  }
}
@font-face {
  font-family: Assamese_Font;
  src: url("../assets/Assamese_font/KirtanUni.ttf");
}
div{
    font-family: arial,Assamese_Font;
}
</style>
